import type { ReactElement } from 'react';

export interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

const STATUS_COLORS: Record<string, { bg: string; text: string; dot: string }> = {
  active: { bg: 'rgba(34, 197, 94, 0.1)', text: 'var(--color-success, #16a34a)', dot: 'var(--color-success, #16a34a)' },
  running: { bg: 'rgba(34, 197, 94, 0.1)', text: 'var(--color-success, #16a34a)', dot: 'var(--color-success, #16a34a)' },
  completed: { bg: 'rgba(59, 130, 246, 0.1)', text: 'var(--color-info, #2563eb)', dot: 'var(--color-info, #2563eb)' },
  done: { bg: 'rgba(59, 130, 246, 0.1)', text: 'var(--color-info, #2563eb)', dot: 'var(--color-info, #2563eb)' },
  paused: { bg: 'rgba(251, 191, 36, 0.1)', text: 'var(--color-warning, #d97706)', dot: 'var(--color-warning, #d97706)' },
  blocked: { bg: 'rgba(251, 191, 36, 0.1)', text: 'var(--color-warning, #d97706)', dot: 'var(--color-warning, #d97706)' },
  failed: { bg: 'rgba(239, 68, 68, 0.1)', text: 'var(--color-error, #dc2626)', dot: 'var(--color-error, #dc2626)' },
  cancelled: { bg: 'rgba(239, 68, 68, 0.1)', text: 'var(--color-error, #dc2626)', dot: 'var(--color-error, #dc2626)' },
  offline: { bg: 'rgba(148, 163, 184, 0.1)', text: 'var(--color-text-muted, #8a7f70)', dot: 'var(--color-border, #ddd7cc)' },
  backlog: { bg: 'rgba(148, 163, 184, 0.1)', text: 'var(--color-text-muted, #8a7f70)', dot: 'var(--color-border, #ddd7cc)' },
  todo: { bg: 'rgba(148, 163, 184, 0.1)', text: 'var(--color-text-muted, #8a7f70)', dot: 'var(--color-border, #ddd7cc)' },
  pending: { bg: 'rgba(148, 163, 184, 0.1)', text: 'var(--color-text-muted, #8a7f70)', dot: 'var(--color-border, #ddd7cc)' },
  in_progress: { bg: 'rgba(139, 92, 246, 0.1)', text: 'var(--color-primary, #c47322)', dot: 'var(--color-primary, #c47322)' },
};

const DEFAULT_COLOR = {
  bg: 'rgba(148, 163, 184, 0.1)',
  text: 'var(--color-text-muted, #8a7f70)',
  dot: 'var(--color-border, #ddd7cc)',
};

export function StatusBadge({ status, size = 'sm' }: StatusBadgeProps): ReactElement {
  const colors = STATUS_COLORS[status] ?? DEFAULT_COLOR;
  const isSmall = size === 'sm';

  return (
    <span
      className="inline-flex items-center font-medium"
      style={{
        gap: 5,
        padding: isSmall ? '2px 8px' : '3px 10px',
        borderRadius: 999,
        fontSize: isSmall ? 10 : 11,
        backgroundColor: colors.bg,
        color: colors.text,
        textTransform: 'capitalize',
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: isSmall ? 5 : 6,
          height: isSmall ? 5 : 6,
          borderRadius: '50%',
          backgroundColor: colors.dot,
          flexShrink: 0,
        }}
      />
      {status.replace(/_/g, ' ')}
    </span>
  );
}
